import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { LabelList, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { computeTrend } from '../../utils/computeTrend.ts';

export const AbsorptionRate = ({
  data,
  disableAnimations = false,
}: {
  data: AbodeAggregateMarketConditions;
  disableAnimations?: boolean;
}) => {
  const chartData: {
    month: string;
    absorptionRate: number;
  }[] = data.monthlyData
    .filter((item) => item.absorption_rate !== null)
    .map((item) => ({
      month: item.month.substring(0, 7),
      absorptionRate: (item.absorption_rate ?? 0) * 100,
    }));
  const maxValue = Math.max(...chartData.map((item) => item.absorptionRate));
  const trendSeries = computeTrend(chartData, 'absorptionRate');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { absorptionRate: 0 }).absorptionRate >=
    (trendSeries[0] || { absorptionRate: 0 }).absorptionRate
      ? '#00B050'
      : '#FF0000';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Absorption Rate (Total Sales Per Month)</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData} margin={{ top: 80, right: 40, left: 0, bottom: 0 }}>
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line
            type="linear"
            dataKey="absorptionRate"
            stroke="#3455DB"
            strokeWidth={2}
            dot={{ r: 3 }}
            isAnimationActive={!disableAnimations}
          >
            <LabelList
              dataKey="absorptionRate"
              position="top"
              fontSize={12}
              offset={10}
              formatter={(value) => `${Math.round(Number(value) * 100) / 100}%`}
            />
          </Line>
          <Line
            type="linear"
            data={trendSeries}
            dataKey="absorptionRate"
            stroke={trendSeriesColor}
            strokeWidth={1}
            dot={false}
            strokeDasharray="5 5"
            isAnimationActive={!disableAnimations}
          />
        </LineChart>
      </ResponsiveContainer>
    </Flex>
  );
};
